import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import AddWard from "./addWard";

const AddWardContainer = () => {


  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <AddWard  />
        </>
      </div>
    </div>
  )
}

export default AddWardContainer